import {Injectable} from '@angular/core';
import {Household, HouseholdProviderSetting, HouseholdWithStores, PatchProviderSettingRequest} from '../../models/household';
import {Observable} from 'rxjs';
import {environment} from '../../env';
import { HttpClient } from '@angular/common/http';
import {UserService} from "../user/user.service";

@Injectable({
  providedIn: 'root'
})
export class HouseholdService {

  constructor(private http: HttpClient, private userService: UserService) {
  }

  households(): Observable<HouseholdWithStores[]> {
    return this.http.get<HouseholdWithStores[]>(`${environment.apiUrl}/households`);
  }

  householdById(householdId: number): Observable<Household> {
    return this.http.get<Household>(`${environment.apiUrl}/households/${householdId}`);
  }

  add(household: Household): Observable<string> {
    return this.http.post<string>(`${environment.apiUrl}/households`, household);
  }

  update(householdId: number, household: Household): Observable<any> {
    this.userService.clearCache();
    return this.http.put<any>(`${environment.apiUrl}/households/${householdId}`, household);
  }

  executeTasks(householdId: number, tasks?: string[]): Observable<any> {
    const payload = tasks && tasks.length > 0 ? { tasks } : {};
    return this.http.post<any>(`${environment.apiUrl}/households/${householdId}/tasks/execute`, payload);
  }

  generateInternalBarcodes(householdId: number): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/households/${householdId}/barcodes`, {});
  }

  delete(householdId: number): Observable<any> {
    this.userService.clearCache();
    return this.http.delete<any>(`${environment.apiUrl}/households/${householdId}`);
  }

  getStockPrompt(householdId: number): Observable<{ prompt: string }> {
    return this.http.get<{ prompt: string }>(`${environment.apiUrl}/households/${householdId}/stock/prompt`);
  }

  getProviderSettings(householdId: number): Observable<HouseholdProviderSetting[]> {
    return this.http.get<HouseholdProviderSetting[]>(`${environment.apiUrl}/households/${householdId}/providers`);
  }

  replaceProviderSettings(householdId: number, settings: HouseholdProviderSetting[]): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/households/${householdId}/providers`, settings);
  }

  patchProviderSetting(householdId: number, providerKey: string, patch: PatchProviderSettingRequest): Observable<void> {
    return this.http.patch<void>(`${environment.apiUrl}/households/${householdId}/providers/${providerKey}`, patch);
  }

  clearProducts(householdId: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/households/${householdId}/products`);
  }

  removeMember(householdId: number, userId: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/households/${householdId}/members/${userId}`);
  }

}
